export default {
  lang: {
    reset: 'Επαναφοράς',
    search: 'Φίλτρος',
    expand: 'Επέκταση',
    collapse: 'Αποθήκη',
  },
};
